<template>
    <div class="landing_areas">
    <v-dialog v-model="dialogDelete" max-width="290">
        <v-card>
            <v-card-title class="headline">
                {{$t('msg_delete_landing_area')}}
            </v-card-title>

            <v-card-text>
                {{$t('msg_eliminar_invitacion_2')}}
            </v-card-text>

            <v-card-actions>
                <v-btn
                        color="primary"
                        @click="dialogDelete = false"
                >
                    No
                </v-btn>
                <v-spacer/>
                <v-btn
                        color="primary"
                        :loading="loadingAddChargeArea"
                        @click="deleteChargeArea"
                >
                    {{$t('Si')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- Diálogo con formulario -->
    <v-dialog v-model="dialogChargeArea" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('landing_area') }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <!-- Nombre del Cliente -->
            <v-text-field
                v-model="cliente.name"
                prepend-icon="forklift"
                :label="$t('nombre')"
                :error-messages="errores.name"
                :rules="[v => !!v || 'El nombre es requerido']"
                color="primary"
            ></v-text-field>
            <!-- Tipod e Area de Carga -->
            <v-autocomplete
                v-model="typeChargeArea"
                prepend-icon="warehouse"
                name="typeChargeArea"
                item-text="name"
                item-value="id"
                :label="$t('type_landing_area')"
                :error-messages="errores.type"
                :items="typesChargeArea"
                :no-data-text="$t('no_resultados')"
            >
            </v-autocomplete>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="dialogChargeArea = false">
            {{ $t('cancelar') }}
          </v-btn>
          <v-btn v-if="update" color="primary" :loading="loadingAddChargeArea" @click="updateChargeArea">
            {{ $t('modificar') }}
          </v-btn>
          <v-btn v-else color="primary" :loading="loadingAddChargeArea" @click="createChargeArea">
            {{ $t('guardar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        <h2 class="subheading grey--text">{{$t('landing_area')}}</h2>
        <v-container class="my-5">
            <v-layout align-center justify-center fill-height>
            <v-btn
                    class="align-self-end"
                    color="primary"
                    @click="abrirDialogClientes">
                    {{ "+ " + $t('add_landing_area') }}
            </v-btn>
            </v-layout>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-layout class="my-4" align-center justify-center fill-height>
                <v-flex >
                    <v-card-title>
                        {{$t('landing_area')}}
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                :label="$t('Buscar')"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :loading="loadingChargeAreas"
                            :items="chargeAreas"
                            :search="search"
                            class="elevation-1"
                            :rows-per-page-text="$t('filas_por_pagina')"
                            :no-data-text="$t('no_records_landing_area')"
                            :rows-per-page-items="[
                            {text: '10', value: 10},
                            {text: '20', value: 20},
                            {text: '25', value: 25},
                            {text: this.$t('todos'),
                            value: -1}]"
                    >
                        <template v-slot:items="props">
                            <td class="justify-center layout px-0">
                                <v-icon
                                        class="mr-2"
                                        @click="fillChargeArea(props.item), errores = [], update = true, id_update = props.item.id"
                                    >
                                    edit
                                </v-icon>
                                <v-icon
                                        medium
                                        color="red"
                                        @click="dialogDelete = true, id_update = props.item.id"
                                >
                                    delete
                                </v-icon>
                            </td>
                            <td>{{ props.item.name }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                        </template>
                        <template v-slot:pageText="props">
                            {{props.rowsPerPage}}
                            {{$t('landing_area')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'

    Vue.use(VeeValidate)
    import { mapState, mapGetters} from 'vuex'

    export default {
        name: "landing_areas",
        data: () => ({
            chargeAreas: [],
            update: false,
            id_update: 0,
            errores: [],
            dialogChargeArea: false,
            search: '',
            headers: [],
            loadingChargeAreas: false,
            valid: true,
            cliente: {
                name: ''
            },
            isLoading: false,
            id_empresa: '',
            loadingAddChargeArea: false,
            typeChargeArea: '',
            dialogDelete: false,
            typesChargeArea: [
                {
                    id: 'ANDEN',
                    name: 'Andén'
                },
                {
                    id: 'ATADOS',
                    name: 'Área de Atados'
                },
                {
                    id: 'RAMPA',
                    name: 'Rampa'
                }
            ]
        }),
        beforeUpdate (){
            this.headers = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('nombre'),
                    align: 'left',
                    sortable: true,
                    value: 'name'
                }
            ]
        },
        created: function () {
            this.get_extra_data()
        },
        computed: {
            ...mapState(['language']),
            ...mapGetters(['getProfile'])
        },
        methods: {
            getChargeAreas (){
                this.loadingChargeAreas = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/shipments/charge-areas/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    params: {
                        IdEmpresa: this.id_empresa,
                        is_active: true
                    }
                };
                axios(config)
                    .then(response => {
                        this.chargeAreas = response.data
                        this.loadingChargeAreas = false
                    })
                    .catch(error => {
                        this.loadingChargeAreas = false
                        console.log(error)
                    })
            },
            get_extra_data (){
                this.loadingChargeAreas = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/auth/me',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.id_empresa = response.data.id_company
                        this.getChargeAreas()
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            abrirDialogClientes() {
                this.update = false
                this.id_update = 0
                this.errores = []
                this.dialogChargeArea = true
                this.$refs.form.resetValidation()
                this.limpiarFormulario()
            },
            fillChargeArea(item) {
                this.dialogChargeArea = true
                this.cliente = {
                    name: item.name
                }
                this.typeChargeArea = item.type
            },
            createChargeArea() {
                this.errores = []
                if (this.$refs.form.validate()) {
                    this.loadingAddChargeArea = true
                    const config = {
                        method: 'post',
                        url: 'https://empresa-service.intrare.app/shipments/charge-areas/',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': this.language ,
                            'authorization': 'Token ' + store.getters.getToken
                        },
                        data: {
                            IdEmpresa: this.id_empresa,
                            name: this.cliente.name,
                            type: this.typeChargeArea
                        }
                    };
                    axios(config)
                        .then(ok => {
                            this.loadingAddChargeArea = false
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_message', this.$t('msg_landing_area'))
                            this.getChargeAreas()
                            this.dialogChargeArea = false
                            this.limpiarFormulario()
                            setTimeout(this.clear, 3000);
                        })
                        .catch(error => {
                            this.loadingAddChargeArea = false
                            if(error.response.status == 400
                                && typeof error.response.data == "object"
                                && error.response.data)
                                this.errores = error.response.data
                        })
                }
            },
            updateChargeArea() {
                this.errores = []
                if (this.$refs.form.validate()) {
                    this.loadingAddChargeArea = true
                    const config = {
                        method: 'patch',
                        url: 'https://empresa-service.intrare.app/shipments/charge-areas/' + this.id_update + '/',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': this.language ,
                            'authorization': 'Token ' + store.getters.getToken
                        },
                        data: {
                            IdEmpresa: this.id_empresa,
                            name: this.cliente.name,
                            type: this.typeChargeArea
                        }
                    };
                    axios(config)
                        .then(ok => {
                            this.loadingAddChargeArea = false
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_message', this.$t('msg_landing_area_updated'))
                            this.getChargeAreas()
                            this.dialogChargeArea = false
                            this.limpiarFormulario()
                            setTimeout(this.clear, 3000);
                        })
                        .catch(error => {
                            this.loadingAddChargeArea = false
                            if(error.response.status == 400
                                && typeof error.response.data == "object"
                                && error.response.data)
                                this.errores = error.response.data
                        })
                }
            },
            limpiarFormulario() {
                this.cliente = {
                    name: ''
                }
                this.typeChargeArea = ''
                this.valid = false
            },
            deleteChargeArea () {
                this.errores = []
                this.loadingAddChargeArea = true
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/shipments/charge-areas/' + this.id_update + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        IdEmpresa: this.id_empresa,
                        is_active: false
                    }
                };
                axios(config)
                    .then(ok => {
                        this.loadingAddChargeArea = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_landing_area_deleted'))
                        this.getChargeAreas()
                        this.dialogDelete = false
                        this.limpiarFormulario()
                        setTimeout(this.clear, 3000);
                    })
                    .catch(error => {
                        this.loadingAddChargeArea = false
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })
            },
            clear: function () {
                this.$validator.reset()
                this.$store.commit('snackbar_activate_false')
            }
        }
    }
</script>
